import { useField, UseFieldConfig } from 'react-final-form';

const useFieldWithError = <
  FieldValue = any,
  T extends HTMLElement = HTMLElement,
  InputValue = FieldValue
>(
  name: string,
  config?: UseFieldConfig<FieldValue, InputValue>
) => {
  const field = useField<FieldValue, T, InputValue>(name, config);

  return {
    ...field,
    meta: {
      ...field.meta,
      error: (!field.meta.dirtySinceLastSubmit && field.meta.submitError) || field.meta.error,
    },
  };
};

export default useFieldWithError;
